import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDiff = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.25 8.75C6.25 8.33579 6.58579 8 7 8H11.25V3.75C11.25 3.33579 11.5858 3 12 3C12.4142 3 12.75 3.33579 12.75 3.75V8H17C17.4142 8 17.75 8.33579 17.75 8.75C17.75 9.16421 17.4142 9.5 17 9.5H12.75V13.75C12.75 14.1642 12.4142 14.5 12 14.5C11.5858 14.5 11.25 14.1642 11.25 13.75V9.5H7C6.58579 9.5 6.25 9.16421 6.25 8.75Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.25 19.25C6.25 18.8358 6.58579 18.5 7 18.5H17C17.4142 18.5 17.75 18.8358 17.75 19.25C17.75 19.6642 17.4142 20 17 20H7C6.58579 20 6.25 19.6642 6.25 19.25Z",
		fill: "currentColor"
	})]
});
export { SvgIconDiff as ReactComponent };
